import { IScorersRankingPlayerPageProps } from "@sky-it-livedata/livedata-sports-design-system";
import { ScorersRankingPlayerPageQuery } from "../types";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { isValidScorersRankingPlayerPage } from "./typeguards";
import {
  NUMBER_OF_HEADSHOTS,
  ADVS_BY_HEADSHOTS,
  ADV_BY_SCORERS,
  LAZY_OFFSET,
  CARDS_COLOR,
  ANALYTICS_ELEMENT,
} from "../constants";
import { intcmpMap } from "../../../utils/intcmp"

export default (
  obj: ScorersRankingPlayerPageQuery
): IScorersRankingPlayerPageProps => {
  if (isValidScorersRankingPlayerPage(obj)) {
    const {
      competitionSlugName,
      competitionName,
      competitionCalendarUrl,
      scorers,
    } = obj.data.getScorersRankingPlayerPage;

    return {
        competitionSlugName: competitionSlugName!,
        numberOfHeadShots: NUMBER_OF_HEADSHOTS,
        advsByHeadshots: ADVS_BY_HEADSHOTS,
        advByScorers: ADV_BY_SCORERS,
        lazyOffset: LAZY_OFFSET,
        cardsColor: CARDS_COLOR,
        competitionCalendarUrl: competitionCalendarUrl!,
        competitionName: competitionName!,
        trackingData: intcmpMap.scorersRankingPlayerPage,
        analyticsElement: ANALYTICS_ELEMENT,
        scorers: scorers!.map((scorer) => ({
            playerSurname: scorer!.playerSurname,
            teamName: scorer!.teamName,
            teamUrl: scorer!.teamUrl!,
            logoUrl: scorer!.logoUrl!,
            position: scorer!.position!,
            goal: scorer!.goal!,
            playerPageLink: scorer!.playerPageLink!,
            playerImageUrl: scorer!.playerImageUrl!,
            seoTeamName: scorer!.seoTeamName!,
        }))
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message:
        "Invalid transformer input, Error in ScorersRankingPlayerPageQuery object",
      data: obj,
    });
  }
};
